export const LibraryQueryKey = 'library'
export const Library = '/api/v1/library'
export const Content = (path: string | null): string =>
  `/api/v1/content/${path}`
